import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(@Inject(DOCUMENT) private document: Document,
              @Inject(PLATFORM_ID) private readonly platformId: any) {}

  openPdfFile(arrayBuffer: ArrayBuffer): void {
    const file = new Blob([arrayBuffer], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    this.document.defaultView?.open(fileURL);
  }

  downloadPdfFile(arrayBuffer: ArrayBuffer): void {
    if (isPlatformBrowser(this.platformId)) {
      const bytes = new Uint8Array(arrayBuffer as ArrayBuffer);
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Facture.pdf';
      link.click();
    }
  }
}
